<template>
	<div class="d-flex align-items-center justify-content-center h-100">
		<div class="col">
			<div class="text-center">
				<h4 class="text-uppercase mt-4">{{$t('header-404')}}</h4>
				<p class="text-muted">{{$t('text-404')}}</p>
				<div class="mt-4">
					<router-link :to="{path: '/'}" class="btn btn-primary waves-effect waves-light">{{$t('btn-goto-main')}}</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Страница не найдена | SKV'});
	},
};
</script>
